import React from "react";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import DashBoard from './DashBoard';
import Style from '../Styles/DashboardStyle.module.css';

const DashBoardRoute =()=>{
    return(
        <div className={Style.DashboardSec+ " "+Style.BoxSpace}>
            <DashBoardLeftProfileMenu/>
            <DashBoard/>

        </div>
       
    )
}

export default DashBoardRoute;